import { api } from './setupApi';

class SiteSettingsModel {
  link = '/site_settings';

  getMaintenanceMode = () => api.get(this.link).then(({ data }) => data);
}

export const siteSettingsModel = new SiteSettingsModel();
